var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 15,
    viewBox: "0 0 24 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1097 1.63652L17.6376 0.173828L6.49169 11.2485L7.9638 12.7111L19.1097 1.63652ZM21.6033 1.92383L12.4852 11.2485L10.908 9.78577L9.43591 11.2485L12.4852 14.1738L23.1805 3.38652L21.6033 1.92383ZM0.603271 8.32308L6.49169 14.1738L7.9638 12.7111L2.07538 6.86039L0.603271 8.32308Z",
    fill: "#ffffff",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.24c2f8e990fe227ee91ed0dc89937335.svg";
export { ForwardRef as ReactComponent };